var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/contentful/product-tray/carousel.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"o-column o-extra-small--12 o-slider-product-tray__wrapper c-product-tray__carousel ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "modifierClass"), env.opts.autoescape);
output += " js-product-tray-grid\" data-qa-product-tray-grid>\n\n<div class=\"o-slider-product-tray o-slider-product-tray--product-image u-centered-content js-slider--product-image\">\n\n    <div class=\"o-slider-product-tray__inner js-slider-product-tray__inner\">\n\n        ";
frame = frame.push();
var t_3 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "tray")),"records");
if(t_3) {var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("record", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "\n\n            <div class=\"o-slider-product-tray__slide o-slider-product-tray__slide--product-image js-slider-product-tray__slide ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0") > 0) {
output += "o-carousel--hidden";
;
}
output += "\" data-qa-product-tray-slide>";
var t_5;
t_5 = (lineno = 10, colno = 48, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [t_4,"allMeta.tile.product.productSlug"]));
frame.set("productSlug", t_5, true);
if(frame.topLevel) {
context.setVariable("productSlug", t_5);
}
if(frame.topLevel) {
context.addExport("productSlug", t_5);
}
var t_6;
t_6 = (lineno = 11, colno = 35, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, ["PAGE_TYPE","product tray|" + "" + runtime.contextOrFrameLookup(context, frame, "eventActionName") + "" + " click",runtime.contextOrFrameLookup(context, frame, "productSlug")]));
frame.set("analytics", t_6, true);
if(frame.topLevel) {
context.setVariable("analytics", t_6);
}
if(frame.topLevel) {
context.addExport("analytics", t_6);
}
var t_7;
t_7 = (lineno = 12, colno = 44, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, ["PAGE_TYPE","product tray|" + "" + runtime.contextOrFrameLookup(context, frame, "eventActionName") + "" + " quickshop",runtime.contextOrFrameLookup(context, frame, "productSlug")]));
frame.set("quickShopAnalytics", t_7, true);
if(frame.topLevel) {
context.setVariable("quickShopAnalytics", t_7);
}
if(frame.topLevel) {
context.addExport("quickShopAnalytics", t_7);
}
output += runtime.suppressValue((lineno = 14, colno = 35, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "displayProductTile"), "displayProductTile", context, [runtime.memberLookup((runtime.memberLookup((t_4),"allMeta")),"tile"),runtime.makeKeywordArgs({"tileTemplate": runtime.contextOrFrameLookup(context, frame, "tileType"),"productIndex": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0"),"analytics": runtime.contextOrFrameLookup(context, frame, "analytics"),"analyticsQuickShop": runtime.contextOrFrameLookup(context, frame, "quickShopAnalytics"),"displayFavorites": runtime.contextOrFrameLookup(context, frame, "displayFavorites"),"lazy": runtime.contextOrFrameLookup(context, frame, "isLazy")})])), env.opts.autoescape);
output += "\n\n            </div>";
;
}
}
frame = frame.pop();
output += "</div>\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/contentful/product-tray/carousel.j2"] , dependencies)